export const PROJECT_ITEMS_SIZE = 200
export const ANNOTATION_ITEMS_SIZE = 200
export const PROJECT_STATS_TASKS_SIZE = 200
export const PROJECT_LOGS_SIZE = 200

export default [ANNOTATION_ITEMS_SIZE, PROJECT_LOGS_SIZE, PROJECT_ITEMS_SIZE, PROJECT_STATS_TASKS_SIZE]
